import { IMG } from "../../lib/assets";
import { TESTIMONIALS } from "../../lib/testimonials";
import { TestimonialBar } from "./TestimonialBar";

export const Transformation = () => {
  return (
    <section
      className="relative py-28 md:py-40 bg-[#F7E9EC] border-y border-[#EDD9DE] overflow-hidden"
      data-testid="transformation-section"
    >
      <div className="max-w-6xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-start">
          <div className="lg:col-span-5 lg:sticky lg:top-24">
            <div className="relative aspect-[3/4] overflow-hidden rounded-2xl shadow-ambient">
              <img
                src={IMG.hands}
                alt="Women joining hands"
                className="img-warm w-full h-full object-cover"
                data-testid="transformation-image"
              />
            </div>
          </div>

          <div className="lg:col-span-7 lg:pt-4">
            <p className="font-body uppercase tracking-[0.3em] text-[10px] text-[#C9587E] font-semibold mb-6">
              What you can expect&hellip;
            </p>
            <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-light leading-[1.05] tracking-tight text-[#3B2630]">
              Nearly all of my clients
              <span className="italic text-[#C9587E]"> 3X their income </span>
              in less than six months.
            </h2>

            <div className="warm-divider-h my-10 max-w-md" />

            <div className="font-body text-base md:text-lg text-[#6B5058] leading-relaxed space-y-5 max-w-2xl">
              <p>
                Because when a woman stops sitting in idea mode and starts
                trusting her instincts, she moves differently.
              </p>
              <p>She makes decisions differently.</p>
              <p className="font-serif italic text-2xl md:text-3xl text-[#3B2630] !mt-10 leading-snug">
                She finds evidence everywhere that life is working in her
                favor, because she trained herself to look for it.
              </p>
            </div>
          </div>
        </div>

        <div className="mt-20 md:mt-28">
          <TestimonialBar
            testid="transformation-testimonials"
            testimonials={[TESTIMONIALS.powerfulStory, TESTIMONIALS.capacity]}
          />
        </div>
      </div>
    </section>
  );
};
